var lastScroll = window.pageYOffset || 0;
var headerOffset = 0;
var filterTouchPoint = null;

(function injectStickyFilterStyles() {
  if (document.getElementById('sticky-filter-anim')) return;
  const style = document.createElement('style');
  style.id = 'sticky-filter-anim';
  style.textContent = [
    '@keyframes filterSlideDown {',
    '  from { opacity: 0; transform: translateY(-12px); }',
    '  to   { opacity: 1; transform: translateY(0); }',
    '}',
    '.filter-entering {',
    '  animation: filterSlideDown 0.28s cubic-bezier(0.22,1,0.36,1) both;',
    '}',
    '.filter-placeholder {',
    '  transition: height 0.28s cubic-bezier(0.22,1,0.36,1);',
    '}'
  ].join('\n');
  document.head.appendChild(style);
}());

const handleScrollResize = () => {
  let scrollCount = window.pageYOffset;
  let diff = scrollCount - lastScroll;
  
  let header = document.querySelector('.shopify-section-header');
  let filter = document.querySelector('.collection-toolbar');
  let announce = document.querySelector('.shopify-section-announcement-bar');
  
  if (!header) return;

  let headerHeight = header.offsetHeight;
  let announceHeight = announce ? announce.offsetHeight : 0;
  if (scrollCount > header.offsetTop) {
    header.classList.add('sticky_header', 'solid_header');
  } else {
    header.classList.remove('sticky_header');
    if (scrollCount === 0) header.classList.remove('solid_header');
  }
  if (document.body.classList.contains('template-index')) {
    let firstSection = document.querySelector('#MainContent .shopify-section');
    let headerTag = header.querySelector('header');
    if (firstSection && headerTag) {
      if (typeof headerTag.dataset.allowTransparent === 'undefined') {
        headerTag.dataset.allowTransparent = headerTag.classList.contains('on-scroll-transparent');
      }
      if (headerTag.dataset.allowTransparent === 'true') {
        let firstSectionRect = firstSection.getBoundingClientRect();
        let headerHeight = header.offsetHeight;
        if (firstSectionRect.bottom <= headerHeight) {
          headerTag.classList.remove('on-scroll-transparent');
        } else {
          headerTag.classList.add('on-scroll-transparent');
        }
      }
    }
  }
  // if(scrollCount > header.offsetTop){
  //   header.classList.add('sticky_header');
  // }
  const announcementBar = document.querySelector('.shopify-section-announcement-bar');
  if(announcementBar && scrollCount < announcementBar.clientHeight &&
  document.querySelector('body').classList.contains('scroll-up')){
    header.classList.remove('sticky_header');
  }

  if (diff > 0) {
    document.body.classList.remove('scroll-up','active-menu');
    document.body.classList.add('scroll-down');
  } else if (diff < 0) {
    document.body.classList.remove('scroll-down','active-menu');
    document.body.classList.add('scroll-up');
  }
  if (scrollCount === 0 && document.body.classList.contains('template-product')) {
    document.body.classList.remove('scroll-up', 'scroll-down');
  }
  if (document.querySelector('.template-collection') || document.querySelector('.template-search')) {
    let headerEl = document.querySelector('body:not(.open-menu) .shopify-section-header');
    let mobileIconsTop = document.querySelector('header.mobile-icons-top');
    
    if (headerEl && filter && !(mobileIconsTop && window.innerWidth <= 991)) {
      document.body.style.setProperty("--header-height", `${headerHeight}px`);
      let placeholder = filter.nextElementSibling;
      if (!placeholder || !placeholder.classList.contains('filter-placeholder')) {
        placeholder = document.createElement('div');
        placeholder.classList.add('filter-placeholder');
        placeholder.style.display = 'none';
        filter.parentNode.insertBefore(placeholder, filter.nextSibling);
      }
      if (placeholder.style.display !== 'block') {
        filterTouchPoint = filter.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      }
      let touchPoint = filterTouchPoint !== null
        ? filterTouchPoint
        : (filter.getBoundingClientRect().top + window.pageYOffset - headerHeight);

      if (scrollCount >= touchPoint) {
        if (placeholder.style.display !== 'block') {
          placeholder.style.height = '0px';
          placeholder.style.display = 'block';
          // trigger reflow so the height transition fires
          placeholder.offsetHeight; // eslint-disable-line no-unused-expressions
          placeholder.style.height = filter.offsetHeight + 'px';

          // filter.style.position = 'fixed';
          filter.style.width = '100%';
          filter.style.zIndex = '1';
          headerEl.style.transition = 'none';
          filter.style.transition = 'none';

          filter.classList.remove('filter-entering');
          filter.offsetHeight; // eslint-disable-line no-unused-expressions
          filter.classList.add('filter-entering');
          filter.addEventListener('animationend', () => filter.classList.remove('filter-entering'), { once: true });

          document.body.classList.add('sticky-filter');
        }
        if (lastScroll < touchPoint) {
           headerOffset = -(scrollCount - touchPoint);
        } else {
           headerOffset -= diff; 
        }
        if (headerOffset < -headerHeight) headerOffset = -headerHeight;
        if (headerOffset > 0) headerOffset = 0;
        headerEl.style.top = `${headerOffset}px`;
        filter.style.top = `${headerHeight + headerOffset}px`;

      } else {
        headerOffset = 0;
        headerEl.style.transition = '';
        filter.style.transition = '';
        headerEl.style.top = '0px';
        
        if (scrollCount > announceHeight) {
           headerEl.classList.add('is-fixed');
        } else {
           headerEl.classList.remove('is-fixed');
        }
        
        if (placeholder.style.display === 'block') {
          filter.style.position = '';
          filter.style.top = '';
          filter.style.width = '';
          filter.style.zIndex = '';
          placeholder.style.display = 'none';
          document.body.classList.remove('sticky-filter');
        }
      }
    }
  }
  let mainCl = document.querySelector('.main-cl');
  if (mainCl) {
    if (window.innerWidth > 991) {
      let topValue = Math.max(50, 76 - scrollCount);
      mainCl.style.top = topValue + 'px';
    } else {
      mainCl.style.top = '';
    }
  }
  updateTopIconsBar();
  lastScroll = scrollCount <= 0 ? 0 : scrollCount;
};
window.addEventListener('scroll', handleScrollResize, { passive: true });
window.addEventListener('resize', handleScrollResize);
document.addEventListener('DOMContentLoaded', handleScrollResize);

function updateTopIconsBar() {
  if (window.innerWidth > 991) return;
  var iconsBar = document.querySelector('header.mobile-icons-top .header__icons');
  if (!iconsBar) return;
  var announceBar = document.querySelector('.section-announcement-bar');
  var announceBottom = announceBar ? Math.max(0, announceBar.getBoundingClientRect().bottom) : 0;
  document.documentElement.style.setProperty('--mobile-icons-top', announceBottom + 'px');
  var barBottom = announceBottom + iconsBar.offsetHeight;
  document.documentElement.style.setProperty('--mobile-icons-bottom', barBottom + 'px');
}

let body = document.body;
let header = document.querySelector('header');
let megaLinks = document.querySelectorAll('.mega-list > a');
let menuTriggers = document.querySelectorAll('.menu-burger, .close-menu');

function updateMenuAriaExpanded(isOpen) {
  document.querySelectorAll('.menu-burger, .mob-close-menu').forEach(btn => {
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
  const drawer = document.getElementById('mobile-menu-drawer');
  if (drawer) drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
}

menuTriggers.forEach(btn => {
  btn.addEventListener('click', function(e){
    e.preventDefault();
    body.classList.remove('open-search');
    body.classList.toggle('open-menu');
    updateMenuAriaExpanded(body.classList.contains('open-menu'));
  });
});
const DESKTOP_BP = 991;

function openMegaMenu(link) {
  let parentLi = link.closest('.mega-list');
  let megaMenu = parentLi.querySelector('.megamenu-inner');
  megaLinks.forEach(l => {
    l.classList.remove('active-link');
    const megaListEl = l.closest('.mega-list');
    megaListEl.classList.remove('mega-open');
    const btn = megaListEl.querySelector('.mega-toggle');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  });
  body.classList.remove('open-drawer', 'open-search', 'open-sort', 'open-filter', 'open-shop-look', 'open-currency');
  link.classList.add('active-link');
  parentLi.classList.add('mega-open');
  const toggleBtn = parentLi.querySelector('.mega-toggle');
  if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
  body.classList.add('open-menu');
  header.style.setProperty('--navOffset', header.offsetHeight + 'px');
  header.style.setProperty('--navHeight', megaMenu.offsetHeight + 'px');
}

function closeMegaMenus() {
  megaLinks.forEach(l => {
    l.classList.remove('active-link');
    const megaListEl = l.closest('.mega-list');
    megaListEl.classList.remove('mega-open');
    const btn = megaListEl.querySelector('.mega-toggle');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  });
  body.classList.remove('open-menu');
  header.style.setProperty('--navOffset', '0px');
  header.style.setProperty('--navHeight', '0px');
}

// Desktop: hover on the parent <li>
document.querySelectorAll('.mega-list').forEach(li => {
  li.addEventListener('mouseenter', function() {
    if (window.innerWidth > DESKTOP_BP) {
      openMegaMenu(li.querySelector(':scope > a'));
    }
  });
  li.addEventListener('mouseleave', function() {
    if (window.innerWidth > DESKTOP_BP) {
      closeMegaMenus();
    }
  });
});

// Mobile: click on the <a>
megaLinks.forEach(link => {
  link.addEventListener('click', function(e) {
    if (window.innerWidth > DESKTOP_BP) return;
    e.preventDefault();
    let isActive = this.classList.contains('active-link');
    closeMegaMenus();
    if (!isActive) {
      openMegaMenu(this);
    }
  });
});

// Desktop keyboard: toggle button opens/closes mega, ArrowDown dives into menu
document.querySelectorAll('.mega-toggle').forEach(btn => {
  btn.addEventListener('click', function() {
    if (window.innerWidth <= DESKTOP_BP) return;
    const link = this.closest('.mega-list').querySelector(':scope > a');
    if (this.getAttribute('aria-expanded') === 'true') {
      closeMegaMenus();
    } else {
      openMegaMenu(link);
    }
  });
  btn.addEventListener('keydown', function(e) {
    if (window.innerWidth <= DESKTOP_BP) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const link = this.closest('.mega-list').querySelector(':scope > a');
      openMegaMenu(link);
      const firstFocusable = this.closest('.mega-list').querySelector('.megamenu a, .megamenu button');
      if (firstFocusable) firstFocusable.focus();
    }
  });
});

// Close mega when focus leaves the entire mega-list (Tab away)
document.querySelectorAll('.mega-list').forEach(li => {
  li.addEventListener('focusout', function(e) {
    if (window.innerWidth <= DESKTOP_BP) return;
    if (!li.contains(e.relatedTarget)) {
      closeMegaMenus();
    }
  });
});
window.addEventListener('resize', function(){
  document.querySelector('header').style.setProperty('--navOffset','0px');
  document.querySelector('header').style.setProperty('--navHeight','0px');
  // document.body.classList.remove('open-menu');
  const activeItem = document.querySelector('.mobile-menu-item.active');
  if(activeItem){
    activeItem.classList.remove('active');
  }
});
document.querySelectorAll('.mob-close-menu').forEach(function(button) {
  button.addEventListener('click', function(e) {
    e.preventDefault();
    document.body.classList.remove('open-menu');
    updateMenuAriaExpanded(false);
    document.querySelectorAll('.snippet-menu-drawer .active').forEach(function(activeEl) {
      activeEl.classList.remove('active');
    });
  });
});
document.querySelectorAll('.snippet-menu-drawer .mobile-nav .mobile-menu-item .has-dropdown').forEach(function(item) {
  item.addEventListener('click', function(e) {
    e.preventDefault();
    const parentItem = this.closest('.mobile-menu-item');
    parentItem.classList.add('active');
    this.setAttribute('aria-expanded', 'true');
  });
});
document.querySelectorAll('.snippet-menu-drawer .mobile-menu-back').forEach(function(backBtn) {
  backBtn.addEventListener('click', function(e) {
    e.preventDefault();
    const parentItem = this.closest('.mobile-menu-item.active');
    if (parentItem) {
      parentItem.classList.remove('active');
      const trigger = parentItem.querySelector('.has-dropdown');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  });
});
if(document.querySelectorAll('.currency_list')) document.querySelectorAll('.currency_list').forEach(function(currency_list) {
  currency_list.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    document.body.classList.toggle('open-currency');
    document.body.classList.remove('open-drawer', 'open-search', 'open-sort', 'open-filter','open-shop-look');
    if (window.innerWidth > 991) {
      document.body.classList.remove('open-menu');
    }
  });
});
document.addEventListener('click', function(e){
  if(!e.target.closest('.currency_list')){
    document.body.classList.remove('open-currency');
  }
});



class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"], input[name="currency"]'),
      panel: this.querySelector('ul'),
    };

    this.querySelectorAll('a').forEach(item =>
      item.addEventListener('click', this.onItemClick.bind(this))
    );
  }
  hidePanel() {
    this.elements.panel.setAttribute('hidden', true);
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth < 768) {
    const currencyItems = document.querySelectorAll(".currency_list");
    currencyItems.forEach(item => {
      item.addEventListener("click", function (e) {
        e.stopPropagation();
          currencyItems.forEach(el => el.classList.remove("active-language"));
          this.classList.add("active-language");
      });
    });
    document.addEventListener("click", function (e) {
        const isInsideMenu = e.target.closest(".currency_list");
        if (!isInsideMenu) {
          currencyItems.forEach(el => el.classList.remove("active-language"));
        }
    });
  }
});


function updateSwymCount(swat) {
  if (!swat) return;
  swat.fetch(function (products) {
    var count = products.length;
    var countElements = document.querySelectorAll(".swym-count");
    countElements.forEach(function (el) {
      el.innerHTML = count;
      if (count > 0) {
        el.style.display = "inline-flex";
      } else {
        el.style.display = "none";
      }
    });
    document.querySelectorAll(".favourite-count").forEach(function (el) {
      el.innerHTML = count;
    });
  });
}

function initSwymCounter(swat) {
  updateSwymCount(swat);
  
  const updateHandler = function() {
    setTimeout(function() {
      updateSwymCount(swat);
    }, 500);
  };

  if (swat.evtLayer && swat.JSEvents) {
    swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, updateHandler);
    swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, updateHandler);
  } else if (swat.evt) {
    swat.evt.on("sw:addedtowishlist", updateHandler);
    swat.evt.on("sw:removedfromwishlist", updateHandler);
    swat.evt.on("sw:removed", updateHandler);
    swat.evt.on("sw:updated", updateHandler);
    swat.evt.on("sw:sync", updateHandler);
  }
}

if (window._swat) {
  initSwymCounter(window._swat);
} else {
  if (!window.SwymCallbacks) window.SwymCallbacks = [];
  window.SwymCallbacks.push(initSwymCounter);
}